module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am640-7c4b4b251153e478c1fa47ce2486b259.jpg";